import { render, staticRenderFns } from "./payman-gateways.vue?vue&type=template&id=e51dcc3e&"
import script from "./payman-gateways.vue?vue&type=script&lang=js&"
export * from "./payman-gateways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports